import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get token from Redux state or storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

export const fetchLatestTemperature = createAsyncThunk(
  "temperature/fetchLatest",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/vitals/patient/${patientId}/temperature/latest`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch temperature");
    }
  }
);

const temperatureSlice = createSlice({
  name: "temperature",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    clearTemperature(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestTemperature.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestTemperature.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchLatestTemperature.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearTemperature } = temperatureSlice.actions;
export const selectTemperature = (state) => state.temperature;
export default temperatureSlice.reducer;



// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// // import { API_URL } from "../../config/config";

// const API_URL = process.env.REACT_APP_API_URL;

// export const fetchLatestTemperature = createAsyncThunk(
//   "temperature/fetchLatest",
//   async (patientId, thunkAPI) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/vitals/patient/${patientId}/temperature/latest`
//       );
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue("Failed to fetch temperature");
//     }
//   }
// );

// const temperatureSlice = createSlice({
//   name: "temperature",
//   initialState: { data: null, loading: false, error: null },
//   reducers: {
//     clearTemperature(state) {
//       state.data = null;
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchLatestTemperature.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLatestTemperature.fulfilled, (state, action) => {
//         state.data = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchLatestTemperature.rejected, (state, action) => {
//         state.error = action.payload;
//         state.loading = false;
//       });
//   },
// });

// export const { clearTemperature } = temperatureSlice.actions;

// export const selectTemperature = (state) => state.temperature;

// export default temperatureSlice.reducer;
